import { Select } from '@gogame/ui/Select';

export const Metric = ({ value, metrics = [], onChange }) => {
  return (
    <Select
      value={value}
      options={metrics}
      onChange={onChange}
      dropdownWidth={220}
      label={'Metric'}
    />
  );
};
